import { render, staticRenderFns } from "./SourceView.vue?vue&type=template&id=6ca6973a"
import script from "./SourceView.vue?vue&type=script&lang=js"
export * from "./SourceView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports